import { CalendarDays } from "lucide-react";
import { MeetingCreate } from "./MeetingCreate";
import { MeetingEdit } from "./MeetingEdit";
import { MeetingList } from "./MeetingList";

export default {
  list: MeetingList,
  create: MeetingCreate,
  edit: MeetingEdit,
  icon: CalendarDays,
  recordRepresentation: "title",
};
